import { useCallback } from "react"

import * as yup from "yup";

export const useYupValidationResolver = (validationSchema: yup.AnySchema) =>
    useCallback(
      async (data: any) => {
        try {
          const values = await validationSchema.validate(data, {
            abortEarly: false,
          })
  
          return {
            values,
            errors: {},
          }
        } catch (err) {
          const errors = err as yup.ValidationError;
          return {
            values: {},
            errors: errors.inner.reduce(
              (allErrors, currentError) => ({
                ...allErrors,
                [currentError.path ?? "unknown"]: {
                  type: currentError.type ?? "validation",
                  message: currentError.message,
                },
              }),
              {}
            ),
          }
        }
      },
      [validationSchema]
    )
  
  